<div class="modal-header bg-dark text-white">
    <h5 class="modal-title text-truncate">
        <i class="fas fa-bullhorn fa-fw mr-2 "></i>
        {{noticeItem.title}}
    </h5>
    <button type="button" class="close text-white" (click)="clickCancel()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="d-flex align-items-center justify-content-between">
        <div class="align-items-center text-muted">
            <i class="far fa-clock fa-fw"></i>
            {{noticeItem.updateDt | filterDateTime:'yyyy-MM-dd HH:mm:ss'}}
        </div>
        <div class="align-items-center text-muted">
            <i class="far fa-check-circle fa-fw"></i>
            view : {{noticeItem.viewCnt}}
        </div>
    </div>
    <hr>
    <div class="mt-4">
        <div [innerHtml]="parseContent(noticeItem.content)"></div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        ngbAutofocus
        (click)="clickCancel()">
        <i class="far fa-times-circle fa-fw"></i>
        확인
    </button>
</div>
